import {cDisplay} from '../creator/cDisplay'
import { cButton } from '../creator/cGameObjects/cButton';
import { cContainer } from '../creator/cGameObjects/cContainer';
import { cInlineDisplay } from '../creator/cGameObjects/cInlineDisplay';
import { cSprite } from '../creator/cGameObjects/cSprite';
import {cScene} from '../creator/cScene'
import { ScreenItem } from '../creator/dataTypes';


export class gameListFristSecond extends cDisplay {

  private curScreen: cInlineDisplay
  private items:any[]
  private isFirstLeft:boolean = true
  private isFirstRight:boolean = true
  private score: number 


  init(){
    super.init()
    var cS:cScene = this.scene as cScene;
    this.score = 4;
    

    (this.scene as cScene).ev.addListener('action',(a,b,c)=>{
      switch (b.command){
        case 'handle_drop':          

          //only check the first drop
          var co = cS.getByName('dt_container') as cContainer
          var targetList = co.getAll()
          var dropTargets = targetList.filter((dt)=>{
            return (dt as any).dragitem && (dt as any).dragitem.length > 0 ? true : false
          })
      
          if (dropTargets.length <= 1){
            var ev:string = ''
            if (String(b.payload.tg).substring(0,3) === 'dt_'){
              ev = String(b.payload.drag).substring(0,3) === 'dir' ? 'correct_left' : 'error_left'
              
            }else{
              ev = String(b.payload.drag).substring(0,3) === 'par' ? 'correct_right' : 'error_right'
              this.checkSide('right')
            }
            cS.triggerSceneEvent(ev)
          }

          this.checkSide( String(b.payload.tg).substring(0,3) === 'dt_' ? 'left' : 'right')
          

          if (targetList.length == dropTargets.length){
          //if (2 == dropTargets.length){
            
            var correct = dropTargets.reduce( (pay:any,val:any)=>{
              if (String(val.name).substring(0,3) === 'dt_' ){
                pay += String(val.dragitem[0].name).substring(0,3) === 'dir' ? 1 : 0
              }else{
                pay += String(val.dragitem[0].name).substring(0,3) === 'par' ? 1 : 0
              }
              return pay
            },0)

            var correct_pos = dropTargets.reduce( (pay:any, val:any)=>{
              if (String(val.name).substring(0,3) === 'dt_' ){
                var curName = val.dragitem[0].name
                var rightIndex = String(val.name).replace('dt_','dtp_')
                var ref = this.getByName(rightIndex)
                var checkName = ref.dragitem[0].name

                var check = {
                  'direct_d':'party_b',
                  'direct_b':'party_c',
                  'direct_c':'party_a',
                  'direct_a':'party_d'                    
                }

                if (check[curName] == checkName){
                  pay ++
                }
               
                console.log('XX',curName,rightIndex,checkName)
              }
              return pay
            },0 )

            if (correct != dropTargets.length){
              cS.triggerSceneEvent('gameeval_error',{score:this.score} )
            }else if(correct_pos != dropTargets.length/2 ){
              cS.triggerSceneEvent('gameeval_error_side',{score:this.score} )
            }else{
              cS.triggerSceneEvent('gameeval_correct',{score:this.score} )
            }
            
            this.score -= dropTargets.length === correct ? 0 : (this.score > 0 ? 1 : 0)
          }

          console.log(b.payload)
          break;
      }
    })
  }

  checkSide(side:string){
    var cS:cScene = this.scene as cScene;

    console.log('CHRCK SIDE', this.isFirstLeft,this.isFirstRight)

    if (side=='left' && this.isFirstLeft){
      if (!this.isFirstRight){
        cS.triggerSceneEvent('match_party')
      }
      this.isFirstLeft = false
    }
    if (side == 'right' && this.isFirstRight){
      if (!this.isFirstLeft){
        cS.triggerSceneEvent('match_party')
      }
      this.isFirstRight = false
    }
  }

  buildScene(){    
    super.buildScene();
  }



}
